<template>
  <avs-chip
    class="min-width-120"
    color="danger"
    icon="mdi-cancel"
    iconColor="white"
    text-color="white"
  >
    {{ $t("commons.status.cancelled") }}
  </avs-chip>
</template>

<script>
export default {
  name: "CancelledChip"
}
</script>
